import type { PortableTextReactComponents } from '@portabletext/react';

import { BlockLink, BlockTable } from '../ui';
export const components: Partial<PortableTextReactComponents> = {
	block: {
		h1: ({ children, value }) => <h1 id={value._key}>{children}</h1>,
		h2: ({ children, value }) => <h2 id={value._key}>{children}</h2>,
		h3: ({ children, value }) => <h3 id={value._key}>{children}</h3>,
		h4: ({ children, value }) => <h4 id={value._key}>{children}</h4>,
		h5: ({ children, value }) => <h5 id={value._key}>{children}</h5>,
		h6: ({ children, value }) => <h6 id={value._key}>{children}</h6>,
		// p in p leads to hydration errors
		p: ({ children }) => <div>{children}</div>,
	},
	marks: {
		link: BlockLink,
	},
	types: {
		table: BlockTable,
	},
};
